export enum SubscriptionPriceType {
  OneTime,
  Recurring,
}
